<template>
  <v-container class="fill-height auth-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <AuthBrandHeader />

        <v-card class="auth-card" flat>
          <v-card-text class="pa-6">
            <template v-if="!emailSent">
              <h1 class="auth-heading">Reset your password</h1>
              <p class="auth-subtext">
                Enter your email and we'll send a reset link.
              </p>

              <v-form
                ref="form"
                v-model="valid"
                autocomplete="off"
                @submit.prevent="sendResetEmail"
              >
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Email"
                  prepend-icon="mdi-email"
                  type="email"
                  autocomplete="off"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-btn
                  class="auth-submit-btn mt-2"
                  type="submit"
                  block
                  large
                  :disabled="!valid || loading"
                  :loading="loading"
                >
                  Send reset link
                </v-btn>
              </v-form>
            </template>

            <template v-else>
              <div class="text-center py-4">
                <v-icon color="success" size="56">mdi-check-circle</v-icon>
                <h1 class="auth-heading mt-4" style="text-align: center">
                  Check your email
                </h1>
                <p class="auth-subtext" style="text-align: center">
                  If your email is registered, you will receive a password reset
                  link shortly.
                </p>
              </div>
            </template>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text class="auth-aux-line">
            Remembered your password?
            <router-link to="/login" class="auth-text-link">
              Back to login
            </router-link>
          </v-card-text>
        </v-card>

        <div class="auth-footer-links">
          <a :href="landingUrl" target="_blank" rel="noopener"
            >About {{ $config.productName }}</a
          >
          <span class="auth-footer-sep">·</span>
          <a :href="'mailto:' + $config.SUPPORT_EMAIL">Support</a>
        </div>

        <!-- Error Alert -->
        <v-alert
          v-if="error"
          type="error"
          dismissible
          class="mt-4"
          @input="clearError"
        >
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AuthBrandHeader from "../components/AuthBrandHeader.vue";

export default {
  name: "ForgotPasswordView",
  components: {
    AuthBrandHeader
  },
  data() {
    return {
      valid: false,
      email: "",
      emailSent: false,
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+\..+/.test(v) || "Email must be valid"
      ]
    };
  },
  computed: {
    ...mapGetters(["loading", "error"]),
    landingUrl() {
      return process.env.VUE_APP_LANDING_PAGE_URL || "https://multisaas.com";
    }
  },
  methods: {
    async sendResetEmail() {
      if (this.$refs.form.validate()) {
        try {
          await this.$store.dispatch("forgotPassword", this.email);
          this.emailSent = true;
        } catch (error) {
          // Error is handled by the store
          console.error("Password reset request failed:", error);
        }
      }
    },
    clearError() {
      this.$store.commit("SET_ERROR", null);
    }
  }
};
</script>
